import * as React from 'react';
import { VenuesList } from './ItemsList/VenuesList';
import InquiryForm from './InquiryForm';
import { CheckoutContext, Steps } from './utils/CheckoutContext';
import { ShoppingCartContext } from '@weddingspot/ws-core-components';
import { AnalyticsEvent, logEvent } from '@weddingspot/ws-analytics';

const styles = require('./CheckOutPage.module.scss');

const Step1 = () => {
    const { step, setConfirmButtonName, setSecondaryButtonName } = React.useContext(CheckoutContext);

    const { items } = React.useContext(ShoppingCartContext);

    React.useEffect(() => {
        if (step === Steps.FirstStep) {
            setConfirmButtonName(`Message ${items.length} venues`);
            setSecondaryButtonName('Cancel');
        }
    }, [step, items]);

    React.useEffect(() => {
        logEvent(AnalyticsEvent.EVTNM_SHOWN_INQUIRY_FORM_CHECKOUT, {});
    }, []);

    return (
        <div className={styles.step1}>
            <VenuesList />
            <InquiryForm />
        </div>
    );
};

export default Step1;
